import { useCurrentAssets } from '../hooks/use-current-assets';
import { useCurrentStaticData } from '../hooks/use-current-static-data';

import { ContainerTopLoading } from './container-top-loading';

export function MapSideLoading() {
  const [, staticDataQuery] = useCurrentStaticData();
  const [, assetsQuery] = useCurrentAssets();

  return (
    <ContainerTopLoading
      isLoading={staticDataQuery.isFetching || assetsQuery.isFetching}
    />
  );
}
